import axios from 'axios';
import { invoke } from '../shims/forge-bridge';

const isAbsoluteUrl = (url: string) => /^https?:\/\//i.test(url);

export class ApiClient {
  static async post(
    url: string,
    payload: unknown,
    headers: { [key: string]: string }
  ): Promise<unknown | undefined> {
    if (isAbsoluteUrl(url)) {
      return (await invoke('asyncPost', {
        url,
        data: payload,
        headers
      })) as unknown;
    }

    const { data } = await axios.post(url, payload, {
      headers: {
        'Content-Type': 'application/json',
        ...headers
      }
    });
    return data;
  }

  static async get(url: string, headers: { [key: string]: string }): Promise<unknown | undefined> {
    if (isAbsoluteUrl(url)) {
      return (await invoke('asyncGet', {
        url,
        headers
      })) as unknown;
    }

    const { data } = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        ...headers
      }
    });
    return data;
  }
}
